module.exports = __webpack_public_path__ + "static/media/progressBarPlatinum.89f88308.svg";